const PendoModalObserver = () => {
  return null;
};

export default PendoModalObserver;
